import { environment } from "@environments/environment";

export const apiUrls = {
	verifyOtp: 			`${environment.api}/biometrics/v1/biometry/validate/otp`,
	publicRSAKey: 		`${environment.api}/security/v1/biometry/security/safe-data/generate/values`,
	onfido: 			`${environment.api}/biometrics/onfido/hybrid-security/onfido-process`,
	lockUser: 			`${environment.api}/biometrics/lock/v1/security/biometry/lock-user`,
	atenea: 			`${environment.api}/biometrics/atn/v1/security/biometry/consult-atenea`,
	generatePin: 		`${environment.api}/biometrics/otp/v1/orq/entrust/management`,
	onfTask:            `${environment.api}/biometrics/onfido/obt/v1/security/biometry/onfido`,
	onfStatus:          `${environment.api}/biometrics/onfido/validate/v1/security/biometry/validate-onfido`
};

export const EXCLUDE_API_ENCRYPT = [
	apiUrls.publicRSAKey
]

export const FORCE_API_ENCRYPT = []